import React from 'react'
import {Icon} from '@chakra-ui/react'

const LeftIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.0542831 20.4396C0.0200005 20.5268 0 20.6182 0 20.7139C0 20.8096 0.0200005 20.9025 0.0542831 20.9896C0.0900002 21.0754 0.142857 21.1539 0.208569 21.2196L13.7943 34.7911C14.0729 35.0696 14.5257 35.0696 14.8043 34.7911C15.0843 34.5125 15.0843 34.0596 14.8043 33.7811L2.43857 21.4282L39.2857 21.4282C39.68 21.4282 40 21.1096 40 20.7139C40 20.3196 39.68 19.9996 39.2857 19.9996L2.43857 19.9996L14.8043 7.64821C15.0843 7.36964 15.0843 6.91678 14.8043 6.63821C14.6657 6.49821 14.4829 6.42821 14.3 6.42821C14.1171 6.42821 13.9343 6.49821 13.7943 6.63821L0.208569 20.2082C0.142857 20.2739 0.0900002 20.3511 0.0542831 20.4396Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="2"
            />
        </Icon>
    )
}

export default LeftIcon
